import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-sections">
        <div className="footer-section">
          <h3>Info</h3>
          <Link to="/info">Learn About Numerease</Link>
        </div>
      </div>
      <p className="copyright">&copy; 2025 Numerease. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
